import { t } from '@/i18n/utils'

/**
 * Member 页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const memberCommonConfig = {
  texts: {
    get signIn() { return t('SignInButton') },
    get myWallet() { return t('MyWallet') },
    get coins() { return t('coins') },
    get topUp() { return t('TopUP') },
    get get() { return t('GetCoins1') },
    // Diamond Card 引流入口标题/文案（原 VIP 口径全量替换）
    get getVip() { return t('diamondCard') },
    get vipMembership() { return t('diamondCard') },
    get moreCoinsMoreBenefits() { return t('diamondCardSlogan') },
    get expires() { return t('Expires') },
    get details() { return t('Details') },
    get transactionHistory() { return t('TransactionHistory') },
    get chaptersUnlocked() { return t('ChaptersUnlocked') },
    get contactUs() { return t('ContactUs') },
    get setting() { return t('Setting') },
  },
}
